import { render } from "./UserSocials.vue?vue&type=template&id=5db59783"
import script from "./UserSocials.vue?vue&type=script&lang=js"
export * from "./UserSocials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__